
/**
 * Keys of all generated SVG sprite symbols.
 */
export type NuxtSvgSpriteSymbol =
  | 'add-hexagon'
  | 'arrow-left'
  | 'arrow-right'
  | 'chevron-down'
  | 'close'
  | 'icons_Sammlung_negativ_Broschuere_offen'
  | 'icons_Sammlung_positive_Broschuere_offen'
  | 'location-pin'
  | 'logo_equans_neg'
  | 'logo_equans_pos'
  | 'logo_kuma_neg'
  | 'logo_kuma_pos'
  | 'logo_swissathletics_neg'
  | 'magnifyingglass'
  | 'newspaper'
  | 'paperplane'
  | 'play'
  | 'vector_scrolldown_herovideo'

export const SPRITE_PATHS = {"default":"/_nuxt/sprite-default.T81RwkEldl.svg"}

export type RuntimeOptions = {
  ariaHidden: boolean
}

export const runtimeOptions: RuntimeOptions = {"ariaHidden":false}
